import { Country } from './type';

export function defineCountry(config: Country): Country {
  return Object.freeze(config); // Immutability at runtime
}
